import { Box, Flex, StyleProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { rem } from '@bonusly/ds-utils';

import { assertIsDateRange } from '../../types';
import { useDatePickerContext } from '../context';

type CalendarHeaderProps = StyleProps;

export const CalendarRangeHeader: FC<CalendarHeaderProps> = (props) => {
	const { t } = useTranslation('components');
	const { interimValue } = useDatePickerContext();

	assertIsDateRange(interimValue);

	return (
		<Flex alignItems="center" mb={1} columnGap={2} {...props}>
			{interimValue.map((date, index) => (
				<Box
					key={index}
					bg="white"
					borderColor="gray.200"
					borderRadius="md"
					borderStyle="solid"
					borderWidth="1px"
					color={date ? 'text.default' : 'text.softest'}
					flexBasis={0}
					flexGrow={1}
					justifyContent="flex-start"
					fontWeight="normal"
					minH={rem(40)}
					px={3}
					py={2}
				>
					{date
						? t('date_picker.date_value_short', {
								date: date,
								interpolation: { escapeValue: false },
							})
						: t('date_picker.date_placeholder')}
				</Box>
			))}
		</Flex>
	);
};
